module.exports = __webpack_public_path__ + "img/calendar.873fcba7.svg";